import { BaseResourceInterface, MiddlewareClient } from '../middleware.types';

export default class BaseResource implements BaseResourceInterface {
  public client: MiddlewareClient;

  constructor(client: MiddlewareClient) {
    this.client = client;
  }
}
